import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./HeaderHome.css";
import Logo from "../../Assets/Svg/Header/MilkyLogo.svg";
import LogoBlue from "../../Assets/Svg/Header/MilkyLogoBlue.svg";
import ButtonContact from "../ButtonContact/ButtonContact";
import ProductMain from "../../Assets/images/Header/ProductHMain.webp";
import ProductH1 from "../../Assets/images/Header/ProductH1.webp";
import ProductH2 from "../../Assets/images/Header/ProductH2.webp";
import ProductH3 from "../../Assets/images/Header/ProductH3.webp";
// import ProductH4 from "../../Assets/images/Header/ProductH4.webp";
import IconLang from "../../Assets/Svg/Header/IconLang.svg";
import IconLangBlue from "../../Assets/Svg/Header/IconLangBlue.svg";
import HeaderArrow from "../../Assets/Svg/Header/H_Arrow_Close.svg";
import HeaderArrowBlue from "../../Assets/Svg/Header/ArrowBlue.svg";
import ROUTES from "../Hooks/RoutesDynamic/RoutesDynamic";
import { RoutesEn } from "../Hooks/RoutesDynamic/RoutesDynamic";

export default function EnHomeHeader() {
  const [showDropdown, setShowDropdown] = useState(null);
  const [hoveredImage, setHoveredImage] = useState(ProductMain);
  const location = useLocation();
  const navigate = useNavigate();

  const [isScrolled, setIsScrolled] = useState(false);
  const currentPath = window.location.pathname;

  const isActive = (path) => currentPath === path;

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerHeight * 0.85;
      if (window.scrollY > scrollThreshold) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLanguageChange = () => {
    const currentPath = location.pathname;
    const isArabic = currentPath.endsWith("/ar");
    const basePath = isArabic ? currentPath.slice(0, -3) : currentPath;
    const newPath = isArabic ? basePath : `${basePath}${basePath.endsWith("/") ? "ar" : "/ar"}`;
    navigate(newPath, { replace: true });
  };

  return (
    <>
      <div className="HeaderContainerBlur">
        <div className={`${isActive("/") ? "Header_Main_Container" : "Header_Main_Container"} ${isScrolled ? "scrolled_link" : ""}`}>
          <div className="Header_Container">
            <div className="Logo">
              <Link to={RoutesEn.Home}>
                <img src={isScrolled ? LogoBlue : Logo} alt="Logo" className="Header_Logo" />
              </Link>
            </div>
            <div className="Menu">
              <div
                className={`Menu_Text TFut16PxPCUC Dropdown_Container ${isScrolled ? "scrolled_link_Text" : ""}`}
                onMouseEnter={() => setShowDropdown("AboutUs")}
                onMouseLeave={() => setShowDropdown(null)}
              >
                About us <img src={isScrolled ? HeaderArrowBlue : HeaderArrow} alt="" className="HeaderArrow" />
                {showDropdown === "AboutUs" && (
                  <div className="About_Dropdown_Menu">
                    <Link to={RoutesEn.OurStory} className="Dropdown_Item TFut16PxPCUC">
                      Our Story
                    </Link>
                    <Link to={RoutesEn.OurValues} className="Dropdown_Item TFut16PxPCUC">
                      Our values
                    </Link>
                    {/* <Link to={ROUTES.BoardMembers} className="Dropdown_Item TFut16PxPCUC">
                      Board Members
                    </Link> */}
                  </div>
                )}
              </div>
              <div
                className={`Menu_Text TFut16PxPCUC Dropdown_Container ${isScrolled ? "scrolled_link_Text" : ""}`}
                onMouseEnter={() => setShowDropdown("OurBrands")}
                onMouseLeave={() => {
                  setShowDropdown(null);
                  setHoveredImage(ProductMain);
                }}
              >
                Our Brands <img src={isScrolled ? HeaderArrowBlue : HeaderArrow} alt="" className="HeaderArrow" />
                {showDropdown === "OurBrands" && (
                  <div className="Product_Dropdown_Menu">
                    <div className="Dropdown_Left">
                      <Link to={RoutesEn.TheMilkman} className="Dropdown_Item TFut16PxPCUC PDDI" onMouseEnter={() => setHoveredImage(ProductH1)}>
                        The Milkman
                      </Link>
                      <Link to={RoutesEn.Reefy} className="Dropdown_Item TFut16PxPCUC" onMouseEnter={() => setHoveredImage(ProductH2)}>
                        Reefy
                      </Link>
                      {/* <Link to={ROUTES.FindOurProducts} className="Dropdown_Item TFut16PxPCUC" onMouseEnter={() => setHoveredImage(ProductH4)}>
                        Find Our Products
                      </Link> */}
                      <Link to={RoutesEn.Recipes} className="Dropdown_Item TFut16PxPCUC" onMouseEnter={() => setHoveredImage(ProductH3)}>
                        Recipes
                      </Link>
                    </div>
                    <div className="Dropdown_Right">
                      <img src={hoveredImage} alt="Brand Preview" className="Dropdown_Image" />
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`Menu_Text TFut16PxPCUC Dropdown_Container ${isScrolled ? "scrolled_link_Text" : ""}`}
                onMouseEnter={() => setShowDropdown("ProductJourney")}
                onMouseLeave={() => setShowDropdown(null)}
              >
                Product Journey <img src={isScrolled ? HeaderArrowBlue : HeaderArrow} alt="" className="HeaderArrow" />
                {showDropdown === "ProductJourney" && (
                  <div className="Journey_Dropdown_Menu">
                    <Link to={RoutesEn.MilkysFarm} className="Dropdown_Item TFut16PxPCUC">
                      mILKY’S FARM
                    </Link>
                    <Link to={RoutesEn.MeetTheCows} className="Dropdown_Item TFut16PxPCUC">
                      Meet The Cows
                    </Link>
                    <Link to={RoutesEn.OurFactory} className="Dropdown_Item TFut16PxPCUC">
                      Our Factory
                    </Link>
                    <Link to={RoutesEn.Logistics} className="Dropdown_Item TFut16PxPCUC">
                      Logistics
                    </Link>
                  </div>
                )}
              </div>
              <Link to={RoutesEn.Csv} className={`Menu_Text TFut16PxPCUC ${isScrolled ? "scrolled_link_Text" : ""}`}>
                CSV
              </Link>
              <Link to={RoutesEn.Careers} className={`Menu_Text TFut16PxPCUC ${isScrolled ? "scrolled_link_Text" : ""}`}>
                Careers
              </Link>
            </div>
            <div className="Language">
              <div className="Header_Languages" onClick={() => setShowDropdown(!showDropdown)}>
                <div className="Header_Languages_Main">
                  <h4 className={`Language_Dropdown_Text TFut16PxPCUC ${isScrolled ? "scrolled_link_Text" : ""}`} onClick={handleLanguageChange}>
                    {/* to top */}
                    العربية <img src={isScrolled ? IconLangBlue : IconLang} alt="" className="IconLang" />
                  </h4>
                </div>
              </div>
              <div>
                <ButtonContact isScrolled={isScrolled} Text="Reach Us" Path={RoutesEn.ReachUs} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="BlurSection"></div>
      <div className="BlurSection2"></div>
      <div className="BlurSection3"></div>
    </>
  );
}
